import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { STORE_TYPE } from '@teem/app/core/constants/defaults';
import { LoaderService } from '@teem/app/core/services/loader.service';
import { SharedDataService } from '@teem/app/core/services/shared-data.service';
import { StoreInformationService } from '@teem/app/core/services/store-information.service';
import { uniqueBranchSlugValidator } from '@teem/app/core/utils/email-unique.validator';
import { ExtraValidators } from '@teem/app/core/utils/ExtraValidators';
import { environment } from '@teem/environments/environment';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import Survicate from '@survicate/survicate-web-package';
import { messages as i18n } from '@teem/constants/messages';
import { fileNameFromUrl } from '@teem/app/utils/functions';
import { GoogleLocationModalComponent } from '../../store-information/modals/google-location-modal/google-location-modal.component';
import { CITY, SAUDI_ARABIA } from '@teem/app/core/constants/country';
import { country as CountryApi , user as UsersApi } from '@teem/core/constants/api';
import { category as CategoryApi} from '@teem/constants/api';

@Component({
  selector: 'app-create-new-branch',
  templateUrl: './create-new-branch.component.html',
  styleUrls: ['./create-new-branch.component.scss']
})
export class CreateNewBranchComponent {
  @Output() close = new EventEmitter<void>();
  @ViewChild('adminInputRef') adminInputRef!: ElementRef<HTMLInputElement>;
  @Input() branchData: any;
  @Input() basicInfo :any;
  @Input() isTemplateData:boolean;
  whatsappNumber: string = '';
  storeFrontCategoriesApi: string = CategoryApi.storeFrontCategoriesApi;
  locationQuery: string = '';
  businessTypes = ['Product', 'Product Rental', 'Service'];
  selectedBusinessType = 'Product';
  editBusinessType = false;
  coverImageUrl: any = '';
  isSubmitted : boolean = false;
  shopStatus: any;
  categories = ['Cakes', 'Muffins', 'Tarts'];
  editCategories = false;
  storeInformationForm: FormGroup;
  coverImageFile: any = null;
  autoAccept: any;
  storeUrl : any;
  selectedCountry: any;
  selectedDistrict: any;
  selectedRegion: any;
  selectedCity: any;
  isLogistiq: boolean = false;
  outsideSA: boolean = true;
  cities: any = '';
  districts: any = '';
  users: any;
  selectedUser: Array<any> = [];
  countryListApi: string = CountryApi.endPoint;
  regionListApi: string = CountryApi.regions;
  cityListApi: string = CountryApi.cities;
  userAllListApi: string = UsersApi.getAll;
  selectedWeekDays: Array<any> = [];
  storefront_selected : any;
  selectedStorefrontCategories: Array<any> = [];

  removeCategory(index: number) {
    this.categories.splice(index, 1);
  }

  constructor(
    private formBuilder : FormBuilder,
    private storeInformationService : StoreInformationService,
    private sharedDataService : SharedDataService,
    private loaderService : LoaderService,
    private modalService : NgbModal
  ){
    this.createStoreFormGroup();
  }

  timeModel: any = {
    sunday: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
  }
  categoryInput: string = '';
  editSchedule = false;

  schedule = [
    {
      day: 'Monday', active: true,slot: [
        { start: '--:--', end: '--:--' }
      ],expanded: false,show: true
    },
    {
      day: 'Tuesday',active: true, slot: [
        { start: '--:--', end: '--:--' }
      ],expanded: false,show: true
    },
    {
      day: 'Wednesday', active: true, slot: [
        { start: '--:--', end: '--:--' }
      ], expanded: false, show: true
    },
    {
      day: 'Thursday', active: true, slot: [
        { start: '--:--', end: '--:--' }
      ], expanded: false, show: true
    },
    {
      day: 'Friday', active: true, slot: [
        { start: '--:--', end: '--:--' }
      ], expanded: false, show: true
    },
    {
      day: 'Saturday', active: true, slot: [
        { start: '--:--', end: '--:--' }
      ], expanded: false, show: true
    },
    {
      day: 'Sunday', active: true, slot: [
        { start: '--:--', end: '--:--' }
      ], expanded: false, show: true
    },
  ];

  get filteredSchedule() {
    return this.schedule.filter(s => s.show);
  }

  get f() {
    return this.storeInformationForm.controls;
  }
  
  get activeSchedule() {
    return this.schedule.filter(s => s.active);
  }

  onActiveChange(day: any): void {
    day.show = day.active; 
  }
  
  toggleDropdown(index: number): void {
    this.schedule[index].expanded = !this.schedule[index].expanded;
  }
  
  get whatsappValue(): string {
    return `https://wa.me/${this.whatsappNumber}`;
  }

  get locationValue(): string {
    return `https://maps.google.com/?q=${this.locationQuery}`;
  }

  closeModal(): void {
    this.close.emit();
  }

  storefront = {
    selected: false,
    uuid: 'unique-storefront-id'
  };

  refs = {
    selected: false,
    uuid: 'unique-refs-id'
  };

  additional = {
    selected: false,
    uuid: 'unique-additional-id'
  };

  deliveryCity = {
    selected: false,
    uuid: 'unique-deliveryCity-id'
  };

  deliveryKSA = {
    selected: false,
    uuid: 'unique-deliveryKSA-id'
  };

  deliveryInt = {
    selected: false,
    uuid: 'unique-deliveryInt-id' 
  };

  everyday = {
    selected: false,
    uuid: 'unique-everyday-id'
  };

  is24HoursOpen = {
    selected: false,
    uuid: 'unique-24HoursOpen-id'
  };

  checkboxes = {
    'unique-storefront-id': this.storefront,
    'unique-refs-id': this.refs,
    'unique-additional-id': this.additional,
    'unique-deliveryCity-id': this.deliveryCity,
    'unique-deliveryKSA-id': this.deliveryKSA,
    'unique-deliveryInt-id': this.deliveryInt,
    'unique-24HoursOpen-id': this.is24HoursOpen,
    'unique-everyday-id': this.everyday
  };

  convertToSlug(input: string) {
    let slug = input.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
    this.storeInformationForm.get('slug').setValue(slug);
    this.storeUrl = `${environment.baseUrl}/${this.basicInfo.slug}/${this.storeInformationForm.get('slug').value}`;
  }

  onCheckboxChange(event: Event, uuid: string): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    const checkbox = this.checkboxes[uuid];
    if (checkbox) {
      checkbox.selected = isChecked;
    }
  }

  storeFrontCheckbox(event: Event){
    const isChecked = (event.target as HTMLInputElement).checked;
    this.storeInformationForm.get('do_not_show_storefront').setValue(isChecked);
    this.storefront_selected = isChecked;
  }

  resetScehdule(inputDay: string){
    const formattedDay = inputDay.charAt(0).toUpperCase() + inputDay.slice(1).toLowerCase();
    const dayEntry = this.schedule.find(d => d.day === formattedDay);
    dayEntry.slot = [];
  }

  updateDayTime(inputDay: string, newStart: string, newEnd: string) {
    const formattedDay = inputDay.charAt(0).toUpperCase() + inputDay.slice(1).toLowerCase();
    const dayEntry = this.schedule.find(d => d.day === formattedDay);

    if (!dayEntry) return;

    // Ensure slots array exists
    if (!Array.isArray(dayEntry.slot)) {
      dayEntry.slot = [];
    }

    dayEntry.slot.push({
      start: newStart,
      end: newEnd
    });
    
  }

  expandDayInput(inputDay: string) {
    const formattedDay = inputDay.charAt(0).toUpperCase() + inputDay.slice(1).toLowerCase();
    const dayEntry = this.schedule.find(d => d.day === formattedDay);
    if (dayEntry) {
      dayEntry.expanded = true;
    }
  }

  coverPhoto: string = 'images/store-branches/img1.webp';
  isDragging: boolean = false;
  position = { top: 0, left: 0 };
  startPosition = { x: 0, y: 0 };

  onChangePhoto(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.coverPhoto = e.target.result;
      };
      reader.readAsDataURL(input.files[0]);
      this.storeInformationForm.patchValue({
        cover_image: input.files[0],
      });
      this.storeInformationForm.get('cover_image')?.updateValueAndValidity();
    }
  }

  onMouseDown(event: MouseEvent): void {
    this.isDragging = true;
    this.startPosition = { x: event.clientX, y: event.clientY };
  }

  onMouseMove(event: MouseEvent): void {
    if (this.isDragging) {
      this.position.left += event.clientX - this.startPosition.x;
      this.position.top += event.clientY - this.startPosition.y;
      this.startPosition = { x: event.clientX, y: event.clientY };
    }
  }

  onMouseUp(): void {
    this.isDragging = false;
  }

  cityDeliveryOption = 'manual';
  cityDeliveryCost: number = 1;
  enableCareemRadius: boolean = true;

  ksaDeliveryCost: number = 1;
  internationalDeliveryCost: number = 1;

  addedAdmins: { name: string; email: string }[] = [];

  addAdmin(): void {
    const input = this.adminInputRef.nativeElement.value.trim();
    if (!input) return;

    const parts = input.split(' ');
    let name = '';
    let email = '';

    if (parts.length === 1 && input.includes('@')) {
      name = input.split('@')[0];
      email = input;
    } else if (parts.length >= 2) {
      email = parts[parts.length - 1];
      name = parts.slice(0, -1).join(' ');
    }

    if (email.includes('@')) {
      this.addedAdmins.push({ name, email });
      this.adminInputRef.nativeElement.value = '';
    }
  }

  removeAdmin(index: number): void {
    this.addedAdmins.splice(index, 1);
  }

  createStoreFormGroup() {
    this.storeInformationForm = this.formBuilder.group({
      name: [null, Validators.required],
      slug: [null, [Validators.required]],
      phone: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(5), Validators.maxLength(30)]],
      whatsapp_phone: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(5), Validators.maxLength(30)]],
      description: [null],
      cover_image: [null],
      do_not_show_storefront: [null],
      shop_comments: [null],
      building_name: [null, Validators.required],
      street: [null, Validators.required],
      area: [null, Validators.required],
      address: [null, Validators.required],
      region: [null],
      country_id: [null, Validators.required],
      district: [null],
      city: [null],
      city_id: [null],
      region_id: [null],
      district_id: [null],
      pin_drop_location: [null],
      branch_id:[null],
      working_days: [[]],
      storefront_categories: [[]],
      week_days: this.newWeekDays(),
      users:[[]]
    }
    );
  }
    
  ngOnChanges(changes: SimpleChanges) {
    if (changes['branchData'] && this.branchData) {
      this.setBranchInfo();
    }
  }

  newWeekDays(): FormGroup {
    const formGroup = this.formBuilder.group({
      same_everyday: [false], // Checkbox for applying the same time to all days
      is_24hour: [false],
      monday: this.createDayGroup(),
      tuesday: this.createDayGroup(),
      wednesday: this.createDayGroup(),
      thursday: this.createDayGroup(),
      friday: this.createDayGroup(),
      saturday: this.createDayGroup(),
      sunday: this.createDayGroup(),
    });
  
    // Listen for changes to 'same_everyday' and update other days accordingly
    formGroup.get('same_everyday')?.valueChanges.subscribe((checked) => {
      if (checked) {
        this.applyMondayToAll(this.storeInformationForm.get('week_days') as FormGroup);
        this.storeInformationForm.get('week_days.is_24hour').setValue(false)
        this.is24HoursOpen.selected = false;
      }
    });

    formGroup.get('is_24hour')?.valueChanges.subscribe((checked) => {
      if (checked) {
        this.apply24ToAll(this.storeInformationForm.get('week_days') as FormGroup);
        this.storeInformationForm.get('week_days.same_everyday').setValue(false)
        this.everyday.selected = false;
      }
    });

    this.updateLabelOnTimeChange(formGroup);

    return formGroup;
  }
  
  // Create a group for each day
  createDayGroup(): FormGroup {
    const group = this.formBuilder.group({
      available: [false],
      slots: this.formBuilder.array([this.createSlot()], this.validateSlotSequence())
    });

    // When "available" changes, update slot validations
    group.get('available')?.valueChanges.subscribe((available: boolean) => {
      const slots = group.get('slots') as FormArray;

      slots.controls.forEach(slot => {
        const startCtrl = slot.get('start_time');
        const endCtrl = slot.get('end_time');

        if (available) {
          startCtrl?.setValidators([Validators.required]);
          endCtrl?.setValidators([Validators.required]);
        } else {
          startCtrl?.clearValidators();
          endCtrl?.clearValidators();
        }

        startCtrl?.updateValueAndValidity({ emitEvent: false });
        endCtrl?.updateValueAndValidity({ emitEvent: false });
      });

      slots.updateValueAndValidity({ emitEvent: false });
    });

    return group;
  }


  getSlots(day: string): FormArray {
    return this.storeInformationForm.get('week_days')!.get(day)!.get('slots') as FormArray;
  }

  addSlot(day: string) {
    const slots = this.getSlots(day);
    slots.push(this.createSlot());

    // 🔥 force validate new + previous slot relationship
    slots.updateValueAndValidity();
  }

  removeSlot(day: string, index: number) {
    this.getSlots(day).removeAt(index);
  }

  validateSlotTime() {
    return (group: AbstractControl) => {
      const dayGroup = group.parent?.parent as FormGroup;

      // If not available, skip validation completely
      if (dayGroup && !dayGroup.get('available')?.value) {
        return null;
      }

      const start = group.get('start_time')?.value;
      const end = group.get('end_time')?.value;

      if (!start || !end) return null;

      const [sH, sM] = start.split(':').map(x => +x);
      const [eH, eM] = end.split(':').map(x => +x);

      const startMin = sH * 60 + sM;
      const endMin = eH * 60 + eM;

      return endMin <= startMin ? { timeInvalid: true } : null;
    };
  }


  validateSlotSequence(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!(control instanceof FormArray)) return null;

      const slots = control.controls;
      let hasError = false;

      // Clear previous errors on each slot first
      slots.forEach(slot => {
        if (slot.hasError('slotOrderInvalid')) {
          slot.setErrors(null);
        }
      });

      for (let i = 1; i < slots.length; i++) {
        const prevEnd = slots[i - 1].get('end_time')?.value;
        const currStart = slots[i].get('start_time')?.value;

        if (!prevEnd || !currStart) continue;

        const [pH, pM] = prevEnd.split(':').map(x => +x);
        const [cH, cM] = currStart.split(':').map(x => +x);

        const prevEndMin = pH * 60 + pM;
        const currStartMin = cH * 60 + cM;

        if (currStartMin <= prevEndMin) {
          // Mark error on current slot control
          slots[i].setErrors({ ...(slots[i].errors || {}), slotOrderInvalid: true });
          hasError = true;
        }
      }

      return hasError ? { slotOrderInvalid: true } : null;
    };
  }

  createSlot(): FormGroup {
    const slot = this.formBuilder.group(
      {
        start_time: [null],
        end_time: [null],
      },
      {
        validators: [this.validateSlotTime()],
      }
    );

    const updateParent = () => {
      const parentArray = slot.parent as FormArray;
      if (parentArray) {
        parentArray.updateValueAndValidity();
      }
    };

    slot.get('start_time')?.valueChanges.subscribe(() => updateParent());
    slot.get('end_time')?.valueChanges.subscribe(() => updateParent());

    return slot;
  }

  applyMondayToAll(weekDaysGroup: FormGroup) {
    const mondayGroup = weekDaysGroup.get('monday') as FormGroup;
    const mondaySlots = (mondayGroup.get('slots') as FormArray).controls as FormGroup[];
    const mondayAvailable = mondayGroup.get('available')?.value;

    const days = ['tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

    // 🔥 Fix — first reset Monday schedule
    this.resetScehdule('monday');

    // 🔥 And update Monday slots to schedule array
    mondaySlots.forEach(slotCtrl => {
        const val = slotCtrl.getRawValue();
        this.updateDayTime('monday', val.start_time, val.end_time);
    });

    days.forEach(day => {
      this.resetScehdule(day);
      const dayGroup = weekDaysGroup.get(day) as FormGroup;
      const daySlots = dayGroup.get('slots') as FormArray;

      while (daySlots.length > 0) {
        daySlots.removeAt(0);
      }

      dayGroup.get('available')?.setValue(mondayAvailable, { emitEvent: false });

      mondaySlots.forEach(slotCtrl => {
        const slotValue = slotCtrl.getRawValue();

        const newSlot = this.createSlot();
        newSlot.patchValue(slotValue, { emitEvent: false });
        daySlots.push(newSlot);

        this.updateDayTime(day, slotValue.start_time, slotValue.end_time);
      });

      daySlots.updateValueAndValidity();
      dayGroup.updateValueAndValidity();
    });
  }


  apply24ToAll(formGroup: FormGroup) {
    const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

    days.forEach((day,idx) => {
      this.resetScehdule(day);
      const dayGroup = formGroup.get(day) as FormGroup;
      const slots = dayGroup.get('slots') as FormArray;

      // 1️⃣ Remove all existing slots
      while (slots.length > 0) {
        slots.removeAt(0);
      }

      // 2️⃣ Create a new single slot
      const slot = this.createSlot();

      // 3️⃣ Set 24-hour time
      slot.get('start_time')?.setValue('00:00', { emitEvent: false });
      slot.get('end_time')?.setValue('23:59', { emitEvent: false });
      this.updateDayTime(day,'00:00', '23:59');
      // 4️⃣ Mark the day as available
      dayGroup.get('available')?.setValue(true, { emitEvent: false });

      // 5️⃣ Add the slot to the day
      slots.push(slot);

      // 6️⃣ Update validations
      slots.updateValueAndValidity();
      dayGroup.updateValueAndValidity();
    });
  }

  updateLabelOnTimeChange(formGroup: FormGroup) {
    ['monday','tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].forEach(day => {
      formGroup.get(day)?.valueChanges.subscribe(() => {
        let startTime = this.storeInformationForm.get('week_days.'+day+'.start_time').value;
        let endTime = this.storeInformationForm.get('week_days.'+day+'.end_time').value;
        this.updateDayTime(day, startTime, endTime);
      });
    });
  }

  // newFormatIn24HoursTime(t: any) {
  //   return moment(`${t.hours}:${t.minutes}:00}`, 'HH:mm:ss').format('HH:mm:ss')
  // }

  // get weekDaysInfo() {
  //   return this.storeInformationForm.get('week_days') as FormGroup;
  // }

  // getWeekDaysFormGroup(index) {
  //   return this.weekDaysInfo.controls[index] as FormGroup;
  // }

  // getNewStartTimeGroup(day) {
  //   return this.getWeekDaysFormGroup(day).controls.new_start_time_group;
  // }

  // getNewEndTimeGroup(day) {
  //   return this.getWeekDaysFormGroup(day).controls.new_end_time_group;
  // }

  // onChangeNewStartTime(day, type = 'new') {
  //   const startTimeValue = this.getNewStartTimeGroup(day).value;
  //   this.storeInformationForm.get('week_days.'+day+'.start_time').setValue(this.newFormatIn24HoursTime(startTimeValue));
    
  //   if (type == 'new') {
  //     let endTime = moment(this.newFormatIn24HoursTime(startTimeValue), 'HH:mm:ss').add(15, 'minutes');
  //     this.storeInformationForm.get('week_days.'+day+'.new_end_time_group').setValue({
  //       hours: endTime.format('HH'),
  //       minutes: endTime.format('mm')
  //     });
  //     this.onChangeNewEndTime(day);
  //   }

  //   setTimeout(function () {
  //     // $('select[nice-select]').niceSelect('update');
  //   }, 100);
  // }

  // onChangeNewEndTime(day) {
  //   const endTimeValue = this.getNewEndTimeGroup(day).value;
  //   this.storeInformationForm.get('week_days.'+day+'.end_time').setValue(this.newFormatIn24HoursTime(endTimeValue));
  // }

  getAllErrors(form: FormGroup | FormArray): { [key: string]: any; } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
      const control = form.get(key);
      const errors = (control instanceof FormGroup || control instanceof FormArray) ? this.getAllErrors(control) : control.errors;
      if (errors) {
        acc[key] = errors;
        hasError = true;
      }
      return acc;
    }, {} as { [key: string]: any; });
    return hasError ? result : null;
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.storeInformationForm.valid) {

      let fd = this.storeInformationForm.value;
      if (this.storeInformationForm.get('cover_image')?.value) {
        fd.cover_image = this.storeInformationForm.get('cover_image')?.value;
      }

      this.loaderService.startLoading();

      this.storeInformationService.createStoreBranch(fd, { headers: { 'Content-Type': 'multipart/form-data' } }).subscribe(
        (res:any) => {
          this.loaderService.stopLoading();
          if(res.state == 'created'){
            Swal.fire(i18n.done, i18n.branch.created, 'success');
          }else{
            Swal.fire(i18n.done, i18n.branch.updated, 'success');
          }
          this.closeModal(); 
        },
        (err) => {
          this.loaderService.stopLoading();
          if (err.status === 422) {
            if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
              let validationErrors = err.error.errors;
              Object.keys(validationErrors).forEach((prop) => {
                this.storeInformationForm.get(prop)?.setErrors({
                  serverError: validationErrors[prop]
                })
              })
            }
          }

          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        }
      )
      this.isSubmitted = false;
    }
  }


  openGoogleMap() {
    const modalRef = this.modalService.open(GoogleLocationModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.result.then(result => {
      this.storeInformationForm.get('pin_drop_location').setValue(result.marker);
      this.storeInformationForm.get('address').setValue(result.address);
    })
  }

  validateInput(event: KeyboardEvent): void {
    const inputChar = String.fromCharCode(event.charCode);
  
    // Regular expression to allow only English, Arabic characters and numbers
    const regex = /^[\u0621-\u064A\u0660-\u0669A-Za-z0-9 ]+$/;
  
    if (!regex.test(inputChar)) {
      event.preventDefault(); // Block the input if it's not a valid character
    }
  }

  onChangeCountry(item) {
    let countryId = item.id;
    if (countryId == 682) {
      this.outsideSA = false;
      this.storeInformationForm.get('city').setValue(null);
      ['city']?.forEach((field: string) => {
        this.storeInformationForm.get(field).setValue(null);
        this.storeInformationForm.get(field).clearValidators();
        this.storeInformationForm.get(field).updateValueAndValidity();
      });
      ['city_id', 'region_id', 'district_id']?.forEach((field: string) => {
        this.storeInformationForm.get(field).setValidators([Validators.required]);
        this.storeInformationForm.get(field).updateValueAndValidity();
      });
    } else {
      this.outsideSA = true;
      ['city'].forEach((field: string) => {
        this.storeInformationForm.get(field).setValidators([Validators.required]);
        this.storeInformationForm.get(field).updateValueAndValidity();
      });

      ['city_id', 'region_id', 'district_id'].forEach((field: string) => {
        this.storeInformationForm.get(field).setValue(null);
        this.storeInformationForm.get(field).clearValidators();
        this.storeInformationForm.get(field).updateValueAndValidity();
      });
    }
  }

  onChangeRegion(item) {
    let region = item.id;
    if (region) {
      this.loaderService.startLoading();
      this.storeInformationService.getCities(region).subscribe((data: any) => {
        this.cities = data;
        this.loaderService.stopLoading();
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
    }
  }

  addCategory(): void {
    const input = this.categoryInput.trim();
    if (input && !this.categories.includes(input)) {
      this.categories.push(input);
      this.selectedStorefrontCategories.push(input);
      this.categoryInput = '';
    }
  }  

  onChangeCity(item) {
    let city = item.id;
    this.isLogistiq = false;
    if (city == CITY.JEDDAH) {
      this.isLogistiq = true
    }
    if (city) {
      this.loaderService.startLoading();
      this.storeInformationService.getDistricts(city).subscribe((data: any) => {
        this.districts = data;
        this.loaderService.stopLoading();
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
    }
  }

  onChangeDistrict(item) {

    if (item && item.id && this.storeInformationForm.get('city_id').value == CITY.JEDDAH) {
      this.loaderService.startLoading();
      this.storeInformationService.getDeliveryCostByDistrict(item.id).subscribe((data: any) => {
        this.loaderService.stopLoading();
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
    }
  }

  setBranchInfo() {
    if (this.branchData) {
      let data = this.branchData;
      this.storeInformationForm.patchValue(data);
      this.coverPhoto = this.isTemplateData ? '' : data.cover_image_url;
      this.storeInformationForm.get('do_not_show_storefront').setValue(!data?.active);
      this.storefront_selected = !data?.active;
      this.storeInformationForm.get('branch_id').setValue(data?.id);
      this.storeInformationForm.get('slug')?.setAsyncValidators(
        uniqueBranchSlugValidator(this.storeInformationService, this.branchData?.id ?? '')
      );
      this.selectedUser = data.branch_users;
      this.storeInformationForm.get('slug')?.updateValueAndValidity(); // IMPORTANT
      if (data.days && (data.days?.length > 0)) {
        this.selectedWeekDays = data.days.map((day) => day.day);
        // new UI
        let tempDay = '';
        data.days.forEach(app => {
          const day = app.day;
          if (!day) return;

          // Mark day as available
          const dayGroup = this.storeInformationForm.get(`week_days.${day}`);
          if (!dayGroup) return;

          dayGroup.get('available')?.setValue(true);
          this.timeModel[day] = true;

          const slotsArray = dayGroup.get('slots') as FormArray;
          if (tempDay != day) {
            tempDay = day;
            slotsArray.clear(); // Remove default slot(s)
            this.resetScehdule(day);
          }

          // Backend may return one or multiple time ranges
          const timeRanges = app.time_ranges ?? [{
            opening_time: app.opening_time,
            closing_time: app.closing_time,
          }];

          timeRanges.forEach(range => {
            const startTime = moment(range.opening_time, 'HH:mm:ss');
            const endTime = moment(range.closing_time, 'HH:mm:ss');

            const slot = this.createSlot();
            slot.patchValue({
              start_time: startTime.format('HH:mm'),
              end_time: endTime.format('HH:mm'),
            });
            this.updateDayTime(day,startTime.format('HH:mm'), endTime.format('HH:mm'));
            slotsArray.push(slot);
          });
        });
      }

      if (data.storefront_categories) {
        this.selectedStorefrontCategories = data.storefront_categories;
      }

      this.shopStatus = data.active === 0 ? false : true;
      // this.autoAccept = data.auto_accept === 0 ? false : true;

      if (data.country_id == SAUDI_ARABIA) {
        this.outsideSA = false;
      }

      if (data.country_id) {
        this.selectedCountry = {
          id: data.country_id,
          name: data.country_name
        }
        this.storeInformationForm.get('country_id').setValue(data.country_id);
        this.onChangeCountry(this.selectedCountry);
      }

      if (data.region_id) {
        this.selectedRegion = {
          id: data.region_id,
          name: data.region_name
        }
        this.storeInformationForm.get('region_id').setValue(data.region_id);
        // this.onChangeRegion(this.selectedRegion);
      }

      if (data.city_name) {
        this.storeInformationForm.get('city').setValue(data.city_name);
      }

      if (data.city_id) {
        this.selectedCity = {
          id: data.city_id,
          name: data.city_name
        }
        this.storeInformationForm.get('city_id').setValue(data.city_id);
        // this.onChangeCity(this.selectedCity);
      }

      if (data.district_id) {
        this.selectedDistrict = {
          id: data.district_id,
          name: data.district_name
        }
        this.storeInformationForm.get('district_id').setValue(data.district_id);
      }

      if (data.slug){
        this.storeUrl = `${environment.baseUrl}/${this.basicInfo.slug}/${data.slug}`;
      }
      if (!data.shop_comments) {
        let shop_comments = this.storeInformationForm.get('shop_comments');
        shop_comments.setValue(null);
        shop_comments.setValidators([]);
        shop_comments.updateValueAndValidity();
      } else{
        // this.storeInformationForm.get('allow_shop_comment').setValue(1);
      }
    }else{
      this.storeInformationForm.get('slug')?.setAsyncValidators(
        uniqueBranchSlugValidator(this.storeInformationService,'')
      );
      this.storeInformationForm.get('slug')?.updateValueAndValidity(); // IMPORTANT
    }
  }
}